import Footer from "./Component/Footer";
// import Header from "./Component/Header";

import { NavLink } from 'react-router-dom'
import Container from 'react-bootstrap/Container';

// import OurEventCards from './Component/OurEventCards';
import OverEventTitleCards from './Component/OverEventTitleCards';
// import EventSchedules from './Component/EventSchedules';
import OurEventData from './Component/OurEventData';
import MenuBar from "./Component/MenuBar";
// import useLatestEvents from '../hooks/useLatestEvents';



const OurEvent = () => {

    // Fetch events from API - COMMENTED OUT TO USE STATIC DATA
    // const { events: apiEvents, loading, error } = useLatestEvents('yugalkunj');

    // Use API events if available, otherwise fallback to hardcoded data
    // const eventData = apiEvents.length > 0 ? apiEvents : OurEventData;

    // Parse date from DD/MM/YYYY format
    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set to start of today

    // Filter events to show only today and future events (hide past events)
    const upcomingEvents = OurEventData.filter(event => {
        const eventDate = parseDate(event.enddate);
        return eventDate >= currentDate;
    });

    // Sort events by date (closest dates first)
    const sortedEvents = upcomingEvents.sort((a, b) => parseDate(a.enddate) - parseDate(b.enddate));

    return (

        <>


            <MenuBar />
            {/* breadcrumb start here */}
            <section className="page-banner">
                <div className="image-layer"></div>
                <div className="upper-icon1"></div>
                <div className="auto-container">
                    <h1>Upcoming Events</h1>
                </div>
                <div className="upper-icon1"></div>
                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><NavLink to='/USA/Home'>Home</NavLink></li>
                            <li className="active">Events</li>
                        </ul>
                    </div>
                </div>

            </section>
            {/*  breadcrum end here */}

            <Container>


                {/* {Object.entries(eventsByDate).map(([date, events]) => (
                <div key={date}>
                    
                    {events.map((event) => (
                    <OverEventTitleCards
                        key={event.id}
                        title={event.title}
                        links={event.links}
                        lablename={event.lablename}
                        enddate={event.enddate}
                        imgscr={event.imgsrc}
                        imglinks={event.imglinks}
                    />

                    
                    ))}
          </div>
        ))} */}
                {sortedEvents.map((val, index) => {
                    return (

                        <OverEventTitleCards
                            key={val.id}
                            title={val.title}
                            titleHtml={val.titleHtml}
                            links={val.links}
                            pagelink={val.pagelinks}
                            pagelinks={val.pagelinks}
                            lablename={val.lablename}

                            imgscr={val.imgsrc}
                            imglinks={val.imglinks}

                        />


                    )

                })}





            </Container>




            <Footer />
        </>


    )




}

export default OurEvent;